import { Route, Switch } from 'react-router'
import PrivateRoute from './PrivateRoute'
import AnomalieTransport from './Admin/Plateforme/AnomalieTransport'
import Attribuer from './Admin/Plateforme/Attribuer'
import ChauffeurAccount from './Account/ChauffeurAccount'
import ClientAccount from './Account/ClientAccount'
import CloseSignature from './CloseSignature'
import Commandes from './Admin/Plateforme/Commandes'
import CommandesList from './CommandesList/CommandesList'
import ComptabiliteByDay from './ComptabiliteClient/ComptabiliteByDay'
import ComptabiliteByDayTransporter from './ComptabiliteTransporteur/ComptabiliteByDayTransporter'
import ComptabiliteByMonth from './ComptabiliteClient/ComptabiliteByMonth'
import ComptabiliteByMonthTransporter from './ComptabiliteTransporteur/ComptabiliteByMonthTransporter'
import ComptabiliteClients from './Admin/Comptabilite/ComptabiliteClients'
import ComptabiliteTransporteurs from './Admin/Comptabilite/ComptabiliteTransporteurs'
import CreateAccount from './CreateAccount/CreateAccount'
import CreateChauffeur from './CreateChauffeur/CreateChauffeur'
import CreateTransporter from './CreateTransporter/CreateTransporter'
import DetailCommandeAdmin from './Admin/Plateforme/DetailCommandeAdmin'
import EditChauffeur from './EditChauffeur/EditChauffeur'
import EditSignalement from './Signaler/Chauffeur/EditSignalement'
import EditSignalementAdmin from './Signaler/Chauffeur/EditSignalementAdmin'
import Facturation from './Admin/Plateforme/Facturation'
import Felicitation from './Felicitation/Felicitation'
import Historique from './Historique/Historique'
import HistoriqueTransporter from './Historique/HistoriqueTransporter'
import HistoriqueChauffeur from './Historique/HistoriqueChauffeur'
import HomePage from './Home/HomePage'
import ListChauffeurs from './ListChauffeurs/ListChauffeurs'
import ListTransportsChauffeurs from './ListTransportsChauffeurs/ListTransportsChauffeurs'
import Map from './Map/Map'
import MesClients from './Admin/MesClients'
import MesTransporteurs from './Admin/Transporteurs/MesTransporteurs'
import MesTransports from './MesTransports/MesTransports'
import NewSignalement from './Signaler/Chauffeur/NewSignalement'
import NotFound from './NotFound/NotFound'
import NouveauxTransporteurs from './Admin/Transporteurs/NouveauxTransporteurs'
import PasserCommande from './PasserCommande/PasserCommande'
import PayCommande from './PayCommande/PayCommande'
import PayHop from './PayHop'
import Plateforme from './Plateforme/Plateforme'
import PublicPasserCommande from './PublicPasserCommande/PublicPasserCommande'
import React from 'react'
import Register from './Register/Register'
import RegisterTransporter from './RegisterTransporter/RegisterTransporter'
import Salon from './Admin/Plateforme/Salon'
import SignInV2 from './SignInV2/SignInV2'
import SignalerChauffeurAll from './Signaler/Chauffeur/SignalerChauffeurAll'
import SignalerClientAll from './Signaler/Chauffeur/SignalerClientAll'
import SingleClient from './Admin/SingleClient'
import SingleClientFacturation from './Admin/Plateforme/SingleClientFacutration'

import SingleTransporter from './Admin/Transporteurs/SingleTransporter'
import Tarif from './Tarif/Tarif'
import TransporterAccount from './Account/TransporterAccount'
import VerfiyEmail from './Register/VerfiyEmail'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import ResetPassword from './ForgotPassword/ResetPassword'
import ComptabiliteSingleClient from './Admin/Comptabilite/ComptabiliteSingleClient'
import ComptabiliteSingleTransporteur from './Admin/Comptabilite/ComptabiliteSingleTransporteur'
import TransporteurListChauffeur from './Admin/Transporteurs/TransporteurListChauffeur'
import SingleChauffeur from './Admin/Transporteurs/SingleChauffeur'
import NouveauxAdministrateur from './Admin/Administrateur/NouveauxAdministrateur '
import MesAdministrateur from './Admin/Administrateur/MesAdministrateur '
import AdministrateurSingle from './Admin/Administrateur/AdministrateurSingle'
import CompteAdministrateur from './Admin/Administrateur/CompteAdministrateur'
import CardSetupFormWrapper from './CardSetupForm/CardSetupFormWrapper'
import CommandeAnnulées from './CommandesAnnulées/CommandeAnnulées'
import CommandeAnnuléesTransporter from './CommandesAnnulées/CommandeAnnuléesTransporter'
import CommandeAnnuléesChauffeur from './CommandesAnnulées/CommandeAnnuléesChauffeur'
import CommandeAnnulles from './Admin/Plateforme/CommandeAnnulles'
import Terminer from './Admin/Plateforme/Terminer'
import MesClientsSupprimer from './Admin/MesClientsSupprimer'
import MesTransporteursSupprimer from './Admin/Transporteurs/MesTransporteursSupprimer'
import NouveauxCommercant from './Admin/Commerçantes/NouveauxCommercant'
import MesCommercant from './Admin/Commerçantes/MesCommercant'
import CommercantSingle from './Admin/Commerçantes/CommercantSingle'
import CreateClient from './CreateClient.js/CreateClient'
import ClientList from './ClientList/ClientList'
import ListCommande from './ListCommande/ListCommande'
import CommercantAccount from './Account/CommercantAccount'
import ListClient from './Admin/Commerçantes/ListClient'
import ListCommandes from './Admin/Commerçantes/ListCommandes'
import ClientAccountForCommercial from './Account/ClientAccountForCommercial'
import ComptabiliteCommercial from './Admin/Commerçantes/ComptabiliteCommercial'
import FailedCharge from './FailedCharge/FailedCharge'
import MesChauffeurs from './Admin/MesChauffeurs'
import ComptabiliteCommerciaux from './ComptabiliteCommerciaux/ComptabiliteCommerciaux'
import MesCommerciauxSupprimer from './Admin/Commerçantes/MesCommerciauxSupprimer'
import ListChauffeurForTransporteurDelete from './Admin/Transporteurs/ListChauffeurForTransporteurDelete'
import SingleFailedCharge from './FailedCharge/SingleFailedCharge'
import Prelevements from './FailedCharge/Prelevements'
import Prelevement from './Prelevement/Prelevement'
import PrelevementDetails from './Prelevement/PrelevementDetails'
import CommerciauxComptabilite from './Admin/Comptabilite/CommerciauxComptabilite'
import AdminArchive from './Admin/Administrateur/AdminArchive'
import HistoriqueChauffeurCommande from './HistoriqueChauffeur/HistoriqueChauffeurCommande'
import HistoriqueTransporteurCommande from './HistoriqueTransporteurCommande/HistoriqueTransporteurCommande'
import DemandeTransfert from '../Components/DemandeTransfert/DemandeTransfert'
import DetailsDemandeTransfert from '../Components/DemandeTransfert/DetailsDemandeTransfert'
import TransportTracking from '../Components/TransportTracking/TransportTracking'
import NewSignalementMiseADispo from './Signaler/Chauffeur/NewSignalementMiseADispo'
import SignalerChauffeurAllAdresse from './Signaler/Chauffeur/SignalerChauffeurAllAdresse'
import SignalerChauffeurAllMission from './Signaler/Chauffeur/SignalerChauffeurAllMission'
import HistoriqueChauffeurMission from './HistoriqueChauffeur/HistoriqueChauffeurMission'
import TransporterStats from './Stats/TransporterStats'
import UpdateDocument from './Admin/Transporteurs/UpdateDocument'
import MissionsClient from './Missions/MissionsClient'
import MissionsTransporteur from './Missions/MissionsTransporteur'
import CommercialStats from './Stats/CommercialStats'
import ClientStats from './Stats/ClientStats'
import Contact from './Contact/Contact'
import SignalerAllCommande from './Signaler/Chauffeur/SignalerAllCommande'
import MissionsCommercial from './Missions/MissionsCommercial'
import Unauthorized from './Unauthorized/Unauthorized'
import PolitiqueConfidentialite from './PolitiqueConfidentialite/PolitiqueConfidentialite'
import PublicRoute from './PublicRoute'
import MissionAdmin from './Missions/MissionAdmin'
import AdminTestPanel from './AdminTestPanel/AdminTestPanel'
import MissionTemplateManager from './MissionTemplateManager/MissionTemplateManager'
import CGVPage from './CGVPage/CGVPage'
import CommandesSupprimees from './Admin/Plateforme/CommandesSupprimees'
function Routes() {
	return (
		<Switch>
			<PublicRoute path='/' component={HomePage} exact />
			<PublicRoute path='/contact' component={Contact} exact />

			<Route
				path='/politique-confidentialite'
				component={PolitiqueConfidentialite}
				exact
			/>
			<Route
				path='/cgv'
				component={CGVPage}
				exact
			/>

			<PrivateRoute
				path='/commandes/new'
				component={PasserCommande}
				roles={['client']}
			/>
			<PrivateRoute
				path='/commandes/:id/pay'
				component={PayCommande}
				roles={['client']}
			/>
			<PrivateRoute
				path='/chauffeurs/new'
				component={CreateChauffeur}
				roles={['transporter']}
			/>

			<PrivateRoute
				path='/chauffeurs/:id/edit'
				component={EditChauffeur}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/chauffeurs'
				component={ListChauffeurs}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/chauffeur/transports/:commande_id/signaler/:signalement_id/edit'
				component={EditSignalement}
				roles={['chauffeur']}
			/>
			<PrivateRoute
				path='/chauffeur/transports/:id/signaler/new'
				component={NewSignalement}
				roles={['chauffeur']}
			/>
			<PrivateRoute
				path='/chauffeur/transports/:id/signaler'
				component={SignalerChauffeurAll}
				roles={['chauffeur']}
			/>

			<PrivateRoute
				path='/chauffeur/transports'
				component={ListTransportsChauffeurs}
				roles={['chauffeur']}
			/>
			<PrivateRoute
				path='/chauffeur/historique'
				component={HistoriqueChauffeur}
				roles={['chauffeur']}
			/>
			<PrivateRoute
				path='/annulées/chauffeur'
				component={CommandeAnnuléesChauffeur}
				roles={['chauffeur']}
			/>

			<PrivateRoute
				path='/admin/historique-tansporteur/:id'
				component={HistoriqueTransporteurCommande}
				exact
			/>
			<PrivateRoute
				path='/transports/historique-chauffeur/:id'
				component={HistoriqueChauffeurCommande}
				exact
			/>
			<PrivateRoute
				path='/transports/mission/historique-chauffeur/:id'
				component={HistoriqueChauffeurMission}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/stats/transporter'
				component={TransporterStats}
				roles={['transporter']}
			/>

			<PrivateRoute
				path='/stats/commercial'
				component={CommercialStats}
				roles={['commercial']}
			/>
			<PrivateRoute
				path='/stats/client'
				component={ClientStats}
				roles={['client']}
			/>
			<PrivateRoute
				path='/transports/:id/single'
				component={SignalerAllCommande}
				roles={[
					'admin',
					'client',
					'chauffeur',
					'transporter',
					'commercial',
					'admin comptabilité',
					'admin service après vente',
					'super admin',
					'admin distribution',
				]}
			/>
			<Route
				path='/edit-document/:token'
				component={UpdateDocument}
				exact
			/>

			<Route
				path='/chauffeur/transports/:id/close'
				component={CloseSignature}
				exact
			/>

		
			<Route
				path='/client/transports/:id/signaler'
				component={SignalerClientAll}
				exact
			/>
			<PrivateRoute
				path='/chauffeur/adresses/:id'
				component={TransportTracking}
				roles={['chauffeur']}
			/>
			<PrivateRoute
				path='/chauffeur/mission/:id/single'
				component={SignalerChauffeurAllMission}
				roles={['chauffeur']}
			/>

			<PrivateRoute path='/commercial/clients' component={ClientList} />
			<PrivateRoute
				path='/commercial/clients/:id/commandes'
				component={ListCommande}
				roles={['commercial']}
			/>
			<PrivateRoute
				path='/commercial/clients/:id/accounts'
				component={ClientAccountForCommercial}
				roles={['commercial']}
			/>
			<Route
				path='/admin/commerçant/clients/:id/commandes'
				component={ListCommandes}
				exact
			/>
			<Route
				path='/admin/commerçant/comptabilite/:id/month'
				component={ComptabiliteCommercial}
				exact
			/>
			<Route
				path='/admin/transports/:id/chauffeur'
				component={TransporteurListChauffeur}
				exact
			/>

			<Route path='/unauthorized' component={Unauthorized} exact />
			<Route path='/admin/chauffeurs' component={MesChauffeurs} exact />
			<Route
				path='/admin/commerciaux/archived'
				component={MesCommerciauxSupprimer}
				exact
			/>
			<Route
				path='/comptabilite/commercial'
				component={ComptabiliteCommerciaux}
				exact
			/>
			<Route
				path='/admin/comptabilite/commerciaux'
				component={CommerciauxComptabilite}
				exact
			/>
			<Route
				path='/admin/failedChargeDetails/:id'
				component={SingleFailedCharge}
				exact
			/>
			<Route
				path='/admin/administrateurs/new'
				component={NouveauxAdministrateur}
				exact
			/>
			<Route
				path='/admin/commercant/new'
				component={NouveauxCommercant}
				exact
			/>
			<Route
				path='/admin/transports-archived/:id/chauffeur'
				component={ListChauffeurForTransporteurDelete}
				exact
			/>

			<Route path='/admin/prelevement' component={Prelevements} exact />

			<Route path='/admin/commerciaux' component={MesCommercant} exact />
			<Route path='/admin/failedcharge' component={FailedCharge} exact />
			<Route
				path='/admin/commerçants/:id/clients'
				component={ListClient}
				exact
			/>
			<Route
				path='/admin/transports/chauffeur/single/:id'
				component={SingleChauffeur}
				exact
			/>
			<Route
				path='/admin/transports-archived/chauffeur/single/:id'
				component={SingleChauffeur}
				exact
			/>
			<Route path='/client/card' component={CardSetupFormWrapper} exact />
			<PrivateRoute
				path='/commercial/client/new'
				component={CreateClient}
				roles={['commercial']}
			/>
			<Route
				path='/chauffeur/missions/:placeID/:commandeID/signaler'
				component={SignalerChauffeurAllAdresse}
				exact
			/>
			<PrivateRoute
				path='/admin/commandes/:id/missions'
				component={MissionAdmin}
				roles={['super admin']}
			/>
			<PrivateRoute
				path='/client/transports/missions/:id'
				component={MissionsClient}
				roles={['client']}
			/>
			<PrivateRoute
				path='/transporter/transports/missions/:id'
				component={MissionsTransporteur}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/commercial/transports/missions/:id'
				component={MissionsCommercial}
				exact
			/>

		

			<PrivateRoute
				path='/chauffeur/missions/:placeID/:commandeID/signaler/new'
				component={NewSignalementMiseADispo}
				roles={['chauffeur']}
			/>

			<Route
				path='/admin/administrateurs'
				component={MesAdministrateur}
				exact
			/>
			<Route
				path='/admin/administrateur/:id'
				component={AdministrateurSingle}
			/>
			<Route
				path='/admin/archive/administrateur/:id'
				component={AdministrateurSingle}
			/>
			<Route path='/admin/commercial/:id' component={CommercantSingle} />
			<Route
				path='/admin/archive/commercial/:id'
				component={CommercantSingle}
			/>
			<Route path='/admin/archived' component={AdminArchive} exact />
			<Route
				path='/admin/account'
				component={CompteAdministrateur}
				exact
			/>
			<Route
				path='/admin/transports/:commande_id/signaler/:signalement_id/edit'
				component={EditSignalementAdmin}
				exact
			/>
			<PrivateRoute
				path='/plateforme'
				component={Plateforme}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/transports'
				component={MesTransports}
				roles={['transporter']}
			/>

			<PrivateRoute
				path='/commercial/account'
				component={CommercantAccount}
				roles={['commercial']}
			/>

			<PrivateRoute
				path='/commandes/list'
				component={CommandesList}
				roles={['client']}
			/>

			<Route path='/verifyEmail' component={VerfiyEmail} />

			{/* Test */}
			<PublicRoute path='/signup' component={Register} />
			<PublicRoute path='/client/signup' component={Register} />
			<PublicRoute
				path='/transporter/signup'
				component={RegisterTransporter}
			/>
			<Route path='/felicitation/client' component={Felicitation} />
			<Route path='/felicitation/transporter' component={Felicitation} />
			{/* <PrivateRoute path='/Home' component={Home} /> */}
			<Route path='/Felicitation' component={Felicitation} exact />
			<PublicRoute
				path='/CreateAccount'
				component={CreateAccount}
				exact
			/>
			<Route
				path='/CreateTransporter'
				component={CreateTransporter}
				exact
			/>

			<PrivateRoute
				path='/client/account'
				component={ClientAccount}
				roles={['client']}
			/>
			<PrivateRoute
				path='/transporter/account'
				component={TransporterAccount}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/chauffeur/account'
				component={ChauffeurAccount}
			/>

			<PrivateRoute
				path='/admin/clients/:id'
				component={SingleClient}
				roles={[
					'admin',
					'super admin',
					'admin distribution',
					'admin service après vente',
				]}
			/>
			<PrivateRoute
				path='/admin/archive/clients/:id'
				component={SingleClient}
				roles={[
					'admin',
					'super admin',
					'admin distribution',
					'admin service après vente',
				]}
			/>

			<PrivateRoute
				path='/admin/clients'
				component={MesClients}
				roles={[
					'admin',
					'super admin',
					'admin distribution',
					'admin service après vente',
				]}
			/>
			<PrivateRoute
				path='/admin/archive/clients'
				component={MesClientsSupprimer}
				roles={[
					'admin',
					'super admin',
					'admin distribution',
					'admin service après vente',
				]}
			/>
          	<PrivateRoute
				path='/mission-templates'
				component={MissionTemplateManager}
				roles={['client']}
			/>
			<Route
				path='/admin/transporteurs'
				component={MesTransporteurs}
				exact
			/>

			<Route path='/pay' component={PayHop} exact />

			<Route
				path='/admin/transporter/:id'
				component={SingleTransporter}
				exact
			/>
			<Route
				path='/admin/archive/transporter/:id'
				component={SingleTransporter}
				exact
			/>
			<Route
				path='/admin/new/transporter/:id'
				component={SingleTransporter}
				exact
			/>
			<Route
				path='/admin/transporteurs/new'
				component={NouveauxTransporteurs}
				exact
			/>
			<Route
				path='/admin/transporteurs/delete'
				component={MesTransporteursSupprimer}
				exact
			/>
			<PrivateRoute
				path='/admin/plateforme/commandes'
				component={Commandes}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>

			<Route
				path='/admin/plateforme/commandes/:id'
				component={DetailCommandeAdmin}
				exact
			/>

			<PrivateRoute
				path='/admin/plateforme/attribuer'
				component={Attribuer}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>

			<PrivateRoute
				path='/admin/plateforme/salon'
				component={Salon}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>

			<Route
				path='/admin/plateforme/facturation'
				component={Facturation}
				exact
			/>

			<Route
				path='/admin/plateforme/facturation/:id'
				component={SingleClientFacturation}
				exact
			/>

			<PrivateRoute
				path='/admin/plateforme/anomalie-transport'
				component={AnomalieTransport}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>
			<PrivateRoute
				path='/admin/plateforme/commandes-supprimees'
				component={CommandesSupprimees}
				roles={[
					'admin',
					'super admin',
					'admin distribution',
					'admin service après vente',
				]}
			/>

			<Route
				path='/admin/comptabilite/clients'
				component={ComptabiliteClients}
				exact
			/>
			<Route
				path='/admin/comptabilite/client/:id'
				component={ComptabiliteSingleClient}
				exact
			/>

			<Route
				path='/admin/comptabilite/transporteurs'
				component={ComptabiliteTransporteurs}
				exact
			/>
			<Route
				path='/admin/comptabilite/transporteur/:id'
				component={ComptabiliteSingleTransporteur}
				exact
			/>

			<Route
				path='/passer-commande'
				component={PublicPasserCommande}
				exact
			/>
			<Route path='/forgot' component={ForgotPassword} exact />
			<Route path='/reset-password/:id' component={ResetPassword} exact />

			<Route
				path='/comptabilite/client/day'
				component={ComptabiliteByDay}
				exact
			/>

			<Route path='/client/prelevement' component={Prelevement} />
			<Route
				path='/client/prelevement-detail/:id'
				component={PrelevementDetails}
				exact
			/>
			<Route
				path='/comptabilite/client/month'
				component={ComptabiliteByMonth}
				exact
			/>

			<Route
				path='/comptabilite/transporter/day'
				component={ComptabiliteByDayTransporter}
				exact
			/>

			<Route
				path='/comptabilite/transporter/month'
				component={ComptabiliteByMonthTransporter}
				exact
			/>

			<PrivateRoute
				path='/historique/client'
				component={Historique}
				roles={['client']}
			/>
			<PrivateRoute
				path='/historique/transporter'
				component={HistoriqueTransporter}
				roles={['transporter']}
			/>
			<PrivateRoute
				path='/annulées/transporter'
				component={CommandeAnnuléesTransporter}
				roles={['transporter']}
			/>

			<PrivateRoute
				path='/annulees/admin'
				component={CommandeAnnulles}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>
			<PrivateRoute
				path='/terminer/admin'
				component={Terminer}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>

			<PrivateRoute
				path='/admin/test-panel'
				component={AdminTestPanel}
				roles={[
					'super admin',
					'admin service après vente',
					'admin',
					'admin distribution',
					'admin comptabilité',
				]}
			/>

			<PrivateRoute
				path='/annulées/client'
				component={CommandeAnnulées}
				roles={['client']}
			/>
			<Route
				path='/admin/demande-transfert/:id'
				component={DemandeTransfert}
				exact
			/>
			<Route
				path='/admin/demande-transfert/details/:id'
				component={DetailsDemandeTransfert}
				exact
			/>

			<PublicRoute path='/login' component={SignInV2} />

			<Route path='/tarif' component={Tarif} exact />

			<Route path='/map' component={Map} exact />

			<Route component={NotFound} />
		</Switch>
	)
}

export default Routes
